import addDays from 'date-fns/add_days';
import addWeeks from 'date-fns/add_weeks';
import addMonths from 'date-fns/add_months';
import isPast from 'date-fns/is_past';
import _isEmpty from 'lodash/isEmpty';

function getNextDateByFrequency(frequency, startDate) {
  if (frequency === 'Daily') {
    return addDays(new Date(startDate), 1);
  }
  if (frequency === 'Weekly') {
    return addWeeks(new Date(startDate), 1);
  }
  if (frequency === 'Monthly') {
    return addMonths(new Date(startDate), 1);
  }
  return null;
}

export const getNextRecurringDay = (frequency, startDate) => {
  let nextDate;

  if (_isEmpty(frequency) && isPast(new Date(startDate))) return null;
  if (
    !isPast(new Date(startDate)) ||
    !isPast(new Date(startDate) && _isEmpty(frequency))
  ) {
    nextDate = startDate;
  } else {
    nextDate = getNextDateByFrequency(frequency, startDate);
  }

  while (isPast(new Date(nextDate))) {
    nextDate = getNextDateByFrequency(frequency, nextDate);
  }

  return nextDate;
};
